import { CommonModule } from '@angular/common';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DIALOG_WIDTH_M, DIALOG_WIDTH_XL } from './core.tokens';

import { RestErrorAuthInterceptor } from './interceptors/rest-error-auth.interceptor';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { AuthService } from './services/features/auth.service';
import { EnablingCoreService } from './services/features/enabling-core.service';
import { ExternalWsService } from './services/features/external-ws.service';
import { NotifyUserService } from './services/features/notify-user.service';
import { PlanCategoriesCoreService } from './services/features/plan-categories-core.service';
import { PlanCoreService } from './services/features/plan-core.service';
import { ProcedureCategoriesCoreService } from './services/features/procedure-categories-core.service';
import { ProcedureCoreService } from './services/features/procedure-core.service';
import { PurposesCoreService } from './services/features/purposes-core.service';
import { ReportSessionService } from './services/features/report-session.service';
import { ReportWorkflowService } from './services/features/report-workflow.service';
import { UsersCoreService } from './services/features/users-core.service';
import { WorkGroupsCoreService } from './services/features/work-groups-core.service';
import { WorkUnitCoreService } from './services/features/work-unit-core.service';
import { StateCacheService } from './services/state-cache.service';
import { CoreEffects } from './store/core.effects';
import { coreFK, reducer } from './store/core.reducer';

@NgModule({
  imports: [
    CommonModule,
    TranslocoModule,

    // ngrx
    StoreModule.forFeature(coreFK, reducer),
    EffectsModule.forFeature([CoreEffects]),
  ],
  providers: [
    RestErrorAuthInterceptor,
    TokenInterceptor,

    StateCacheService,

    // shared feature services
    AuthService,
    EnablingCoreService,
    WorkUnitCoreService,
    WorkGroupsCoreService,
    PurposesCoreService,
    ExternalWsService,
    NotifyUserService,
    ProcedureCategoriesCoreService,
    ProcedureCoreService,
    PlanCategoriesCoreService,
    PlanCoreService,
    UsersCoreService,
    ReportSessionService,
    ReportWorkflowService,
    { provide: DIALOG_WIDTH_XL, useValue: '80%' },
    { provide: DIALOG_WIDTH_M, useValue: '40%' }
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule?: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}
